import { useState } from 'react';
import styles from './index.module.scss';
import { useEffect } from 'react';
import { TweenMax } from 'gsap';
import { useLang } from '@/i18n';
import EFVideo from '@/components/UI/EFVideo';

const programme = styles.programme;
export default function Programme() {
    const { t } = useLang('ecocreditsday.pageTabs.tabB');
    const [videoReady, setVideoReady] = useState(false);

    useEffect(() => {
        const scene = new ScrollMagic.Scene({
            triggerElement: `.${programme}`,
            offset: 300, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: 300,
        });
        const tweenA1 = TweenMax.to(`.${programme} .text-box`, 0.5, { opacity: 1 });
        scene.setTween(tweenA1);
        controllerDay.addScene(scene);

        return () => {
            scene && scene?.destroy();
        };
    }, []);

    return (
        <div className={styles.programme}>
            <div className="text-box">
                <div className="sub-title">{t('programme.sub_title')}</div>
                <div className="title">{t('programme.h5Title') || t('programme.title')}</div>
                <div className="desc">{t('programme.h5Desc') || t('programme.desc')}</div>
            </div>
            <div className="video-box">
                <EFVideo
                    className={`video ${videoReady ? 'videoReady' : ''}`}
                    width={videoReady ? '100%' : '1px'}
                    height={videoReady ? 'auto' : '1px'}
                    sources={['/media/ecocredits-day/h5/programme.webm', '/media/ecocredits-day/h5/programme.mp4']}
                    onPlay={() => {
                        setVideoReady(true);
                    }}
                />
            </div>
        </div>
    );
}
